import React, { useEffect, useRef, useState } from "react";

const MIN_HEIGHT = 44;
const MAX_HEIGHT = 256;
const INITIAL_HEIGHT = 72;

export default function LogQueryEditor({ value, onChange, onSearch, logqlMode }) {
  const [height, setHeight] = useState(INITIAL_HEIGHT);
  const fieldRef = useRef(null);

  const onKeyDown = (event) => {
    if (event.key !== "Enter" || event.shiftKey || event.isComposing) return;
    event.preventDefault();
    if (!event.repeat) onSearch();
  };

  useEffect(() => {
    const rememberHeight = () => {
      const next = fieldRef.current?.offsetHeight;
      if (next >= MIN_HEIGHT) {
        setHeight(Math.min(MAX_HEIGHT, next));
      }
    };
    window.addEventListener("mouseup", rememberHeight);
    window.addEventListener("touchend", rememberHeight);
    return () => {
      window.removeEventListener("mouseup", rememberHeight);
      window.removeEventListener("touchend", rememberHeight);
    };
  }, []);

  return (
    <div className="log-query-editor">
      <textarea
        aria-label="Log query"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        ref={fieldRef}
        onKeyDown={onKeyDown}
        placeholder={logqlMode
          ? "LogQL query, for example level = \"ERROR\" AND service = \"api-gateway\""
          : "Search message, Trace ID, or name…"}
        className={`log-search-input${logqlMode ? " log-search-input-logql" : ""}`}
        style={{
          resize: "vertical",
          minHeight: MIN_HEIGHT,
          maxHeight: MAX_HEIGHT,
          height,
          overflow: "auto",
          ...(logqlMode ? { borderColor: "#3b82f6", backgroundColor: "#eff6ff" } : {})
        }}
      />
      <p className="log-search-hint">Shift+Enter for a new line. Enter or Ctrl/Cmd+Enter to search.</p>
    </div>
  );
}
